export function QueryBuilder<T>(query: T): string {
    const queryBuilder = new URLSearchParams();
    for (const key in query) {
        if (Array.isArray(query[key])) {
            const values = Array.from(query[key] as any).map((field) => field).join(',');
            queryBuilder.append(key, values);
        } else if (String(query[key]) !== "") {
            queryBuilder.append(key, query[key as string]);
        }
    }
    return queryBuilder.toString();
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/queryBuilder.ts